import React from 'react';
import type { FabricCanvas } from '../../types/fabric';
import { ColorsUsedPanel } from '../panels/ColorsUsedPanel';
import { LayerPanel } from '../panels/LayerPanel';

interface RightPanelProps {
  canvas: FabricCanvas | null;
  /** Fired when a layer row is clicked in the LayerPanel below — the caller
   *  (DesignerApp) uses this to switch the LEFT tool panel into its 'edit'
   *  tool (PropertyPanel), which now lives there instead of stacked in this
   *  panel. Keeps the two panels decoupled: this component only reports the
   *  intent, DesignerApp owns activeTool. */
  onEditLayer?: () => void;
}

export function RightPanel({ canvas, onEditLayer }: RightPanelProps) {
  return (
    <div style={{
      width: 260,
      flexShrink: 0,
      background: '#ffffff',
      borderLeft: '1px solid #e2e8f0',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Two stacked sections, each given a fixed share of the panel's height
          (per direct user request) so a long list in either one scrolls
          WITHIN its own slot instead of pushing the other off screen or
          growing the whole sidebar. Order: Colors Used in Design (25% — a
          handful of swatches, rarely needs more), Layers (75% — a list that
          can grow with the design, and no longer has to share room with the
          Text/Image edit section, which moved to the LEFT tool panel — see
          onEditLayer above). Each child panel fills its slot's 100% height
          and manages its own overflowY. */}
      <div style={{ height: '25%', minHeight: 0, overflowY: 'auto', borderBottom: '1px solid var(--border)' }}>
        <ColorsUsedPanel canvas={canvas} />
      </div>
      <div style={{ height: '75%', minHeight: 0 }}>
        <LayerPanel canvas={canvas} onLayerSelected={onEditLayer} />
      </div>
    </div>
  );
}
